<template>
  <section style="position:relative" id="section">

    <el-row class=""  style="padding:15px 0;background:#fff">
    
      <el-button size="medium" type="primary" @click="addProduct">新增</el-button>
      <el-button size="medium" type="success" @click="changeStatus(false,1)">启用</el-button>
      <el-button size="medium" type="danger" @click="changeStatus(false,0)">禁用</el-button>
      <!--<el-input
	        @clear="getList"
	        @keyup.enter.native="search"
	        ref="input"
	        class="search  xs24"
	        v-model="pdata.kw"
	        clearable
	        placeholder="请输入公司名称"
	        :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
	    ></el-input>-->
	    <el-select v-model="pdata.kw" filterable  clearable    placeholder="请选择公司名称">
		    <el-option
		      v-for="item in companyList"
		      :key="item.id"
		      :label="item.name"
		      :value="item.id">
		    </el-option>
			</el-select>
   <!--   <el-button size="medium" type="info" @click="changeStatus(false,-1)">删除</el-button>-->
		
     
		 
    </el-row>
    <!--列表-->
    <el-table
      :data="plist"
      style="width: 100%;min-width:1200px"
      stripe
      row-key="id"
      @selection-change="select"
      class="demo-table"
    >
     <el-table-column type="selection" min-width="30px"></el-table-column>
     <el-table-column prop="id" fixed label="ID" min-width="50px" width="50" align="center"></el-table-column>
     <el-table-column prop="name" fixed label="公司名称" min-width="50px" align="center" >
     

     			<!--<template slot-scope="scope">
					      <el-button size="medium" type="text"   @click="$router.push({name:'扣量规则详情',params:{index_id:scope.row.id}})">{{scope.row.name}}</el-button>
     		 </template>-->
     </el-table-column>
     <el-table-column prop="short_name" fixed label="公司别名" min-width="50px" align="center" > </el-table-column>
     <el-table-column prop="tax_point" fixed label="发票类型" min-width="50px" align="center"  >
	     	<template slot-scope="scope">
					<span>{{scope.row.invoice_type==1?'普通发票':'增值发票'}}</span>  <span v-if="scope.row.tax_point>0">({{scope.row.tax_point}}%)</span> 
	      </template>
     </el-table-column>
     <el-table-column prop="ald_key" fixed label="结算类型" min-width="50px" align="center">
     		<template slot-scope="scope">
					<span>{{scope.row.type==1?'对公':'对私'}}</span> 
	      </template>
     </el-table-column>

     





     <el-table-column prop="status" fixed label="激活状态" min-width="50px" width="150"  align="center">
     	<template slot-scope="scope">
          <el-button
            size="mini"
            :type="scope.row.status=='1'?'success':'danger'"
            @click="changeStatus(true,scope.row)"
          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
        </template>
     </el-table-column>
     <el-table-column prop="status" fixed label="操作" min-width="50px" width="150"  align="center">
     		 <template slot-scope="scope">
			<!--		      <el-button size="medium" type="danger" @click="deleteProduce(true,scope.row)">删除</el-button>-->
					      <el-button size="medium" type="primary" @click="editRule(scope.row)">编辑</el-button>
     		 </template>
     </el-table-column>
     
    
    </el-table>
   

    <div class="pageRow">
      <el-pagination
        class="pagination"
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page.sync="pdata.page"
        :page-sizes="[20, 40, 60, 80]"
        :page-size="pdata.perpage"
        background
        layout="sizes, prev, pager, next, jumper"
        :total="pdata.perpage*maxPage"
      ></el-pagination>
    </div>


    <el-dialog
      :title="isAdd?'添加公司':'编辑公司'"
      :visible.sync="editDialog"
      top="5vh"
      width="750px"
      custom-class="dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="chooseProduct" :rules="rules" ref="ruleForm" :label-width="formLabelWidth">
      	
        <el-row :gutter="5" style="margin:0;">
        	
        	
        	
        	
        	<el-col :span="24">
        		<el-form-item label="公司信息"> </el-form-item>
        	</el-col>
        	<el-col :span="24">
        		<el-form-item label="结算类型">
        			 <el-select v-model="chooseProduct.type" placeholder="请选择">
						    <el-option
						      v-for="item in options2"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						  </el-select>
        		</el-form-item>
        	</el-col>
        	
        	<el-col :span="24" v-if="chooseProduct.type==1">
        		<el-form-item label="企业"  prop="name"> 
	        		<el-input v-model="chooseProduct.name" placeholder="输入企业名称"></el-input>
        		</el-form-item>
        	</el-col>
        	<el-col :span="24" v-if="chooseProduct.type==1">
        		<el-form-item label="企业别名"  prop="short_name"> 
	        		<el-input v-model="chooseProduct.short_name" placeholder="输入企业别名"></el-input>
        		</el-form-item>
        	</el-col>
        	<el-col :span="24" v-if="chooseProduct.type==2">
        		<el-form-item label="个人"  prop="name">
        			<el-input v-model="chooseProduct.name" placeholder="输入个人名称"></el-input></el-form-item>
        	</el-col>
        	<el-col :span="24">
        		<el-form-item label="纳税人识别号"> <el-input v-model="chooseProduct.social_credit_code" placeholder="输入统一社会信用码"></el-input></el-form-item>
        	</el-col>
        		<el-col :span="24">
        		<el-form-item label="注册地址"> <el-input v-model="chooseProduct.company_addr" placeholder="输入注册地址"></el-input></el-form-item>
        	</el-col>
        	<el-col :span="24">
        		<el-form-item label="注册电话"> <el-input v-model="chooseProduct.company_phone" placeholder="输入注册电话"></el-input></el-form-item>
        	</el-col>
        	
        	<el-col :span="24">
        		<el-form-item label="开票信息"> </el-form-item>
        	</el-col>
        	<el-col :span="24">
        		<el-form-item label="发票类型" prop="invoice_type" v-if="chooseProduct.type==1">
        			 <el-select v-model="chooseProduct.invoice_type" placeholder="请选择">
						    <el-option
						      v-for="item in options"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						  </el-select>
        		</el-form-item>
        	</el-col>
        	<el-col :span="24">
        		<el-form-item label="开户行" prop="opening_bank"> <el-input v-model="chooseProduct.opening_bank"  placeholder="输入开户行"></el-input></el-form-item>
        	</el-col>
        	<el-col :span="24">
        		<el-form-item label="收款账号"  prop="receiving_account"> <el-input v-model="chooseProduct.receiving_account" placeholder="输入收款账号"></el-input></el-form-item>
        	</el-col>
        	
        	
        	<el-col :span="24">
        		<el-form-item label="税点">
        			<el-select v-model="chooseProduct.tax_point" placeholder="请选择">
        				<el-option key="0" label="0" value="0"> </el-option>
						    <el-option key="3.36" label="3.36" value="3.36"> </el-option>
						    <el-option key="6.72" label="6.72" value="6.72"> </el-option>
						  </el-select>
        		
        		</el-form-item>
        	</el-col>
        	
        
        	<el-col :span="24">
        		<el-form-item label="收件信息"> </el-form-item>
        	</el-col>
        	<el-col :span="24">
        		<el-form-item label="联系人"> <el-input v-model="chooseProduct.contact" placeholder="输入联系人"></el-input></el-form-item>
        	</el-col>
    			<el-col :span="24">
        		<el-form-item label="邮寄地址"> <el-input v-model="chooseProduct.email_addr" placeholder="输入邮寄地址"></el-input></el-form-item>
        	</el-col>
        	<el-col :span="24">
        		<el-form-item label="联系电话"> <el-input v-model="chooseProduct.phone" placeholder="输入电话"></el-input></el-form-item>
        	</el-col>
        	
        
       
        	
        
        	<el-col :span="24">
        		<el-form-item label="备注"> <el-input v-model="chooseProduct.remark" placeholder="备注"></el-input></el-form-item>
        	</el-col>
        	
        </el-row>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新日志" :visible.sync="logDialog">
      <el-table :data="plog">
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
import { getCPCompanyList2,getCPCompany, CPcompanyAdd, CPcompanyStatus, CPcompanyEdit,selectCPCompany} from "../../api/api";
//import UploadImg from "./uploadImg.vue";

export default {
  components: {
//  UploadImg
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入企业/个人名称", trigger: "blur" }],
        opening_bank:[{ required: true, message: "请输入开户行", trigger: "blur" }],
        receiving_account:[{ required: true, message: "请输入收款账号", trigger: "blur" }],
        invoice_type:[{required: true, message: "请选择发票类型", trigger: "blur" }],
       
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_name:"",
        theme: "",
        status: "",
        kw: "",
        sort_field: "",
        sort_by: "",
        placement:"",
      },
      plist: [],
      companyList:[],
      billCompany:[],
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [], //日志
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      pText:"请选择产品投放位置",
      imageUrl: "",

      headMsg: {
        token: ""
      },
      imageUrl: "",
      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      }, //修改选中的产品状态,批量修改状态
      selectProduct: [], //批量修改选中的产品
      prWidth: 0,
      options: [{ value: '0', label: '请选择发票类型' },  { value: '1', label: '普通发票' }, { value: '2', label: '增值发票' } ], //发票类型
      options2:[{value:'1',label:'对公'},{value:'2',label:'对私'}], //公司类型
      chooseProduct: {
      	"type":"1",
			  "name":"",
			  "short_name":"",
				"opening_bank":"",
				"receiving_account":"",
				"social_credit_code":"",
				"contact":"",
				"phone":"",
				"invoice_type":"0",
				"tax_point":"",
				"company_addr":"",
				"email_addr":"",
				"remark":"",
				"log":"",
				"company_phone":""
			},
    };
  },
  watch: {
  	"pdata.kw": {
    	handler(n, o) {
      	this.getList();
    	},
      deep: true
    }

  },
  methods: {
  	search() {
      this.getList();
    },
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getCPCompanyList2(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        		this.plist = res.data.list;
            this.maxPage = res.data.max_page;
        	}
          
        }
      });
      selectCPCompany('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        		this.companyList = res.data.list;
        	}
          
        }
      });
//    getCPCompany('', this.$cookie.getCookie("login")).then(res => {
//      if (res.code == 200) {
//      	if(res.data&&res.data.length>0){
//      		this.billCompany = res.data;
//      	}
//        
//      }
//    });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    placementFilter(s){
    	this.pText = s == "" ? "请选择产品投放位置" : s;
    	this.pdata.placement = s;
    	this.getList();
    },
    search() {
      // this.$refs.input.blur();
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editRule(d) {
      this.editDialog = true;
      this.chooseProduct = JSON.parse(JSON.stringify(d));
      this.chooseProduct.index_id=d.id;
      delete this.chooseProduct.create_time;
      this.isAdd = false;
    },
    changeStatus(isSingle, s) {
      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = "删除产品";
      }
      CPcompanyStatus(this.cP, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.getList();
          this.$message({ message: this.cP.log + "成功", type: "success" });
        }
      });
    },
    deleteProduce(isSingle,s){
    	if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status ='-1';
      }
    	 ruleStatus(this.cP, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.getList();
          this.$message({ message: this.cP.log + "成功", type: "success" });
        }
      });
    	
    },
    addProduct() {
    	this.chooseProduct= {
    		"type":"1",
			  "name":"",
			  "short_name":"",
				"opening_bank":"",
				"receiving_account":"",
				"social_credit_code":"",
				"contact":"",
				"phone":"",
				"invoice_type":"0",
				"tax_point":"",
				"company_addr":"",
				"email_addr":"",
				"remark":"",
				"log":"",
				"company_phone":""
			},
      this.editDialog = true;
      this.isAdd = true;
    },
    submit() {
    	


			
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.isAdd) {
          	
          	
          	var p =this.chooseProduct;
            CPcompanyAdd(p, this.$cookie.getCookie("login")).then(
              res => {
                if (res.code == 200) {
                	this.$message({
					          message: '添加成功',
					          type: 'success'
					        });
                  this.getList();
                  this.editDialog = false;
                } else {
                  this.$message.error(res.msg);
                }
              }
            );
          } else {
            this.$prompt("请输入编辑原因", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
              inputErrorMessage: "内容不能为空"
            }).then(({ value }) => {
                this.chooseProduct.log = value;
              var p =this.chooseProduct;
              CPcompanyEdit(p, this.$cookie.getCookie("login")).then(
                res => {
                  if (res.code == 200) {
                    this.getList();
                    this.editDialog = false;
                  } else {
                    this.$message.error(res.msg);
                  }
                }
              );
            });
          }
        } else {
          return false;
        }
      });
    },
    select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getInfo(s) {
      this.chooseProduct = JSON.parse(JSON.stringify(s));
      delete this.chooseProduct.id;
      this.chooseProduct.path='';
      this.chooseProduct.placement=''
      this.chooseProduct.log = "新增复用产品";
      this.chooseTags = this.chooseProduct.tags.split(",");
    }
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },
  mounted() {
    this.getList();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};
</script>
<style scoped lang="scss">
span.gn{
	color: #20A0FF;
	cursor: pointer;
}
.dialog {
  width: 800px;
}
.size {
  width: 100px;
  text-align: right;
  position: absolute;
  top: 20px;
  left: -100px;
  padding-right: 14px;
  box-sizing: border-box;
  color: #999;
  font-size: 12px;
}
</style>

<style >
.demo-table .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    min-width: 200px;
    padding: 0 25px;
}
.demo-table .demo-table-expand label {

    color: #99a9bf;
}
.el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: top;
}
.el-upload-list__item {
  line-height: 0;
}
.selectRow {
  min-width:1200px;padding:15px;background: #fff;
}
.statusRow {
  background: #f2f6fc;
  padding: 15px;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  min-width: 600px;
}
.statusRow > .el-button {
  margin-right: 6px;
}
.gameIcon {
  width: 60px;
  height: 60px;
  border-radius: 6px;
}
.dropdown {
  min-width: 120px;
  width: 170px;
}
.dropdown-menu {
  width: 170px;
  margin: 0 auto;
  text-align: center;
}
.search,
.input {
  width: 220px;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
.pageRow {
  min-width: 1200px;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  left: 0;
  bottom: -20px;
  z-index: 1000;
}
@media only screen and (max-width: 767px) {
  .phoneHide {
    display: none;
  }
  .search {
    width: 60px;
  }
  .selectRow {
    min-width: 300px;
    padding: 5px;
  }
  .dropdown {
    width: 100%;
  }
  .dropdown-menu {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// cpcompanylist.vue?28f58a0e